import { axiosInstance } from '@/rest'

const createReportsApi = () => {
  return {
    getIntraday: () => axiosInstance.get('reports/intraday'),
  }
}

const reportsApi = createReportsApi()

export { reportsApi }
